export default class AccountPayableActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_ACCOUNTPAYABLE='GET_HELPER_ACCOUNTPAYABLE';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: AccountPayableActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: AccountPayableActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: AccountPayableActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: AccountPayableActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: AccountPayableActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: AccountPayableActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: AccountPayableActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: AccountPayableActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: AccountPayableActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: AccountPayableActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: AccountPayableActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: AccountPayableActions.GET_HELPER_ACCOUNTPAYABLE,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: AccountPayableActions.ERROR_SERVER,
      payload: error
    };
  }
}